import API from './Api';


const USER_TOKEN = "USER_TOKEN";

const userService = {
	getToken: () => {
		return localStorage.getItem(USER_TOKEN);
	},
	setToken: (token) => {
		return new Promise((resolve, reject) => {
			//decrypt ton token, valide le et set tes datas dans le localStorage
			localStorage.setItem(USER_TOKEN, token);
			resolve();
		});
	},
	auth(email, password) {
		return new Promise((resolve, reject) => {
			API.login(email, password).then(response => {
				var token = ((response || {}).data || {}).token;
				var base64Url = token.split('.')[1];
				var base64 = base64Url.replace('-', '+').replace('_', '/');
				var tmp = JSON.parse(window.atob(base64));
				if(tmp['roles'].indexOf("ROLE_ADMIN") >= 0){
					userService.setToken(token).then(() => {
						resolve(true);
					})
				}else{
					reject("** Your are not alowed");
				}
			});
		});
	},
};


export { userService as default };


// WEBPACK FOOTER //
// ./src/services/userService.js